<script>
import ModuleTitle from '../common/ModuleTitle.vue'
import CheckMoreText from '../common/CheckMoreText.vue'

import { getShadowColor } from '@/utils/modules/getStyles'

export default {
  name: 'Comp11',
  components: { ModuleTitle, CheckMoreText },
  props: {
    moduleOption: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      path: this.$route.path
    }
  },
  methods: { getShadowColor }
}
</script>

<template>
  <div class="modules-id-11">
    <module-title :title="moduleOption.title" margin-bottom="24" />
    <div class="comp-transverse-3 modules-id-11-content pointer">
      <div class="img-group">
        <el-image
          v-for="v in moduleOption.list.slice(0, 2)"
          :key="`modules-11-${v.id}`"
          class="item-img"
          :style="{boxShadow: `0 3px 10px 0 ${getShadowColor(path)}`}"
          :src="v.photo | imgPath"
          alt="activity"
          fit="cover"
        />
      </div>
      <check-more-text class="check-more-11" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.modules-id-11-content {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.img-group {
  width: 419px;
  display: flex;
  justify-content: space-between;
}
.item-img {
  width: 193px;
  max-height: 285px;
  border-radius: 5px;
}
.check-more-11 {
  margin-top: 24px;
}
</style>
